'use es6';

import { combineReducers } from 'redux';
import listing from './listing';
import reviews from './reviews';
export default combineReducers({
  listing,
  reviews
});